<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form
      :model="queryParams"
      label-width="70px"
      class="demo-form-inline"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <!-- 物资类别 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="物资名称">
            <el-input
              v-model="queryParams.key_word"
              placeholder="请输入物资名称"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <!-- 报废时间 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="报废时间">
            <el-date-picker
              v-model="queryParams.useDateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
              style="width: 100%"
              @change="handleDateChange"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 按钮区域 -->
      <div>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button @click="handleExport">导出</el-button>
      </div>
    </el-form>

    <!-- 固定物资表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
    >
      <el-table-column prop="assetCatName" label="物资类别" />
      <el-table-column prop="fixedAssetName" label="物资名称" />
      <el-table-column prop="nationalAssetsCode" label="国资编码" />
      <el-table-column label="数量">
        <template slot-scope="scope">
          {{ scope.row.stockInCount || 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="approvePersonName" label="审批人" />
      <el-table-column prop="approveStatus" label="状态">
        <template v-slot="scope">
          <span>{{
            APPROVE_STATUS_MAP[scope.row.approveStatus] || "未知"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="approveRemark" label="审核理由" />
      <el-table-column prop="applyDate" label="报废发起时间" />
    </el-table>

    <!-- 分页 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />
  </div>
</template>

<script>
import { getScrapOutStockLog, getScrapOutStockLogExport } from "@/api/material";
import PaginationBar from "@/components/PaginationBar";
import { STAMP_STATUS, APPROVE_STATUS_MAP } from "@/utils/const.js";
import { listToMap, downloadFile } from "@/utils/util";

const STAMP_STATUS_MAP = listToMap(STAMP_STATUS);

export default {
  name: "ScrapRecord",
  components: { PaginationBar },
  data() {
    return {
      APPROVE_STATUS_MAP,
      STAMP_STATUS_MAP,
      queryParams: {
        key_word: "",
        useDateRange: [],
      },
      startCreateTime: "",
      endCreateTime: "",
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.startCreateTime = dateRange[0]; // "2025-05-30 00:00:00"
        this.endCreateTime = dateRange[1]; // "2025-06-02 23:59:59"
      } else {
        this.startCreateTime = "";
        this.endCreateTime = "";
      }
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      getScrapOutStockLog({
        key_word: this.queryParams.key_word,
        page_no: this.currentPage,
        page_size: this.pageSize,
        begin_date: this.startCreateTime,
        end_date: this.endCreateTime,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        key_word: "",
        useDateRange: [],
      };
      this.startCreateTime = "";
      this.endCreateTime = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    handleTabChange() {
      this.resetQuery();
    },
    handleExport() {
      getScrapOutStockLogExport({
        key_word: this.queryParams.key_word,
        page_no: this.currentPage,
        page_size: this.pageSize,
        begin_date: this.startCreateTime,
        end_date: this.endCreateTime,
      }).then((res) => {
        downloadFile(
          res.data,
          "固定物资报废记录数据.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
</style>
